import React from 'react';
import { Typography, Box } from '@fullstory/components';
import { ALERTS_UPDATE, generateRoutePath } from '@fullstory/routes';
import { AlertAndKey } from '@fullstory/client-api';
import { ConfiguredAlertItem } from '../ConfiguredAlertItem';
import { Link } from 'react-router-dom';
import { alertSexpr, segmentIdFromKey } from '../../utils';
import { SegmentsById } from '@fullstory/redux';
import { FormattedMessage } from 'react-intl';
import css from '../../styles/alerts/alertsOverlay.module.scss';

export const TeamAlerts: React.FC<{
  teamAlerts: AlertAndKey[];
  orgId: string;
  segments: SegmentsById;
  onCloseSignal: () => void;
}> = ({ teamAlerts, orgId, segments, onCloseSignal }) => (
  <>
    {teamAlerts.length > 0 ? (
      <>
        <Box padding={24}>
          <Typography variant="heading8">
            <FormattedMessage defaultMessage="Team Alerts" id="Vbvf9Y" />
          </Typography>
        </Box>
        <Box>
          {teamAlerts.map(alert => {
            const segmentId = segmentIdFromKey(alert.Key);
            const segment = segments[segmentId];
            if (segment == null) return null;
            return (
              <Link
                key={alert.Key.AlertId + alert.Alert.CreatedAt}
                className={css.noUnderline}
                to={generateRoutePath(ALERTS_UPDATE, {
                  orgId,
                  segmentId,
                  alertId: alert.Key.AlertId,
                  search: alertSexpr(alert.Alert),
                })}
              >
                <ConfiguredAlertItem alert={alert} segment={segment} onClick={onCloseSignal} />
              </Link>
            );
          })}
        </Box>
      </>
    ) : null}
  </>
);
